<template>
  <div class="clearfix">
    <div class="input-select-item">
      <span class="input-select-item-label"> {{ $t('message["1658"]') }}：</span>
      <div class="input-select-item-cell">
        <a-select
          v-model="datas.fontFamily"
          class="select-normal"
        >
          <a-select-option :value="1">
            Arial
          </a-select-option>
          <a-select-option :value="2">
            Courier
          </a-select-option>
          <a-select-option :value="3">
            Georgia
          </a-select-option>
          <a-select-option :value="4">
            Helvetica
          </a-select-option>
          <a-select-option :value="5">
            MicroSoft YaHei
          </a-select-option>
          <a-select-option :value="6">
            PingFang SC
          </a-select-option>
          <a-select-option :value="7">
            Tahoma
          </a-select-option>
          <a-select-option :value="8">
            Verdana
          </a-select-option>
          <a-select-option :value="9">
            {{ $t('message["1155"]') }}
          </a-select-option>
          <a-select-option :value="10">
            {{ $t('message["434"]') }}
          </a-select-option>
        </a-select>
      </div>
    </div>
    <div class="input-select-item">
      <span class="input-select-item-label"> {{ $t('message["1656"]') }}：</span>
      <div class="input-select-item-cell">
        <a-input-number
          v-model="datas.contentSize"
          class="input-normal"
        />
      </div>
    </div>
    <div class="input-select-item">
      <span class="input-select-item-label">{{ $t('message["1576"]') }}：</span>
      <div class="input-select-item-cell">
        <a-input
          v-model="datas.contentColor"
          class="input-color"
        />
        <color-picker
          :color="datas.contentColor"
          @setColor="setBgColor"
        />
      </div>
    </div>
  </div>
</template>
<script>
import ColorPicker from './ColorPicker'
export default {
  components: {
    ColorPicker
  },
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    datas () {
      return this.itemData.font
    }
  },
  methods: {
    setBgColor (c) {
      this.datas.contentColor = c
    }
  }
}
</script>
